import { useContext, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import MainLayout from '../../Layout/MainLayout';
import PageContainer from '../../components/layout/PageContainer';
import PredefineItineraryContext from '../../context/predefineItinerary/PredefineItineraryContext';
import PredefineItineraryHeader from './sections/Header/PredefineItineraryHeader';
import AccessRestricted from './sections/Shared/AccessRestricted';
import PredefineItineraryList from './sections/PredefineItineraryList/PredefineItineraryList';
import PredefineItineraryForm from './sections/PredefineItineraryForm/PredefineItineraryForm';

const PredefinedItineraryPage = () => {
  const {
    currentUserRole,
    itineraries,
    locations,
    loading,
    fetchItineraries,
    fetchLocations,
    showModal,
    editingItem,
    viewOnly,
    setViewOnly,
    uploading,
    durationDays,
    setDurationDays,
    durationNights,
    setDurationNights,
    formData,
    setFormData,
    isRestricted,
    updateDurationState,
    handleOpenCreate,
    handleOpenEdit,
    handleOpenView,
    handleCloseModal,
    handleFileUpload,
    addDay,
    removeDay,
    updateDayField,
    addPointer,
    removePointer,
    updatePointer,
    handleSubmit,
    handleDelete
  } = useContext(PredefineItineraryContext);

  useEffect(() => {
    if (!isRestricted) {
      fetchItineraries();
      fetchLocations();
    }
  }, [isRestricted, fetchItineraries, fetchLocations]);

  return (
    <MainLayout activeTab="your-itinerary">
      <PageContainer className="font-sans">
        {/* Header */}
        <PredefineItineraryHeader
          isRestricted={isRestricted}
          showModal={showModal}
          onAddClick={handleOpenCreate}
        />

        {/* Restricted Access Card for Bookings Role */}
        {isRestricted ? (
          <AccessRestricted currentUserRole={currentUserRole} />
        ) : (
          <AnimatePresence mode="wait">
            {showModal ? (
              <PredefineItineraryForm
                formData={formData}
                setFormData={setFormData}
                locations={locations}
                editingItem={editingItem}
                viewOnly={viewOnly}
                setViewOnly={setViewOnly}
                uploading={uploading}
                durationDays={durationDays}
                setDurationDays={setDurationDays}
                durationNights={durationNights}
                setDurationNights={setDurationNights}
                updateDurationState={updateDurationState}
                onBack={handleCloseModal}
                onFileUpload={handleFileUpload}
                onAddDay={addDay}
                onRemoveDay={removeDay}
                onUpdateDayField={updateDayField}
                onAddPointer={addPointer}
                onRemovePointer={removePointer}
                onUpdatePointer={updatePointer}
                onSubmit={handleSubmit}
              />
            ) : (
              <PredefineItineraryList
                itineraries={itineraries}
                loading={loading}
                onAddClick={handleOpenCreate}
                onView={handleOpenView}
                onEdit={handleOpenEdit}
                onDelete={handleDelete}
              />
            )}
          </AnimatePresence>
        )}
      </PageContainer>
    </MainLayout>
  );
};

export default PredefinedItineraryPage;
